import React, { useRef } from "react";
import { connectAutoDispatch } from "redux/reduxConnect";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import apiCaller from "utils/axios";
import { Flex, Radio, Space, Spin, Typography } from "antd";
import { apiWalmartCallback } from "../../../api/user";

const { Text, Link } = Typography;

const { AZ_API_URL_NEW, SP_APP_ID, SP_BETA_VERSION, SP_REDIRECT_URL } = process.env;

const baseURL = `${AZ_API_URL_NEW}/walmart`;

const WalmartCallback = ({ classes, userInfo, enqueueSnackbar }) => {
  const history = useHistory();
  const [state, setState] = React.useState({
    loading: false,
    error: null,
    user: null,
    authorizedRegions: [],
    authorized: true,
    errorMessage: {},
    waiting: false,
    errorEmail: "",
    errorSellerId: ""
  });

  const errorElm = useRef(null);

  const getAuthParams = () => {
    const searchParams = new URLSearchParams();
    return searchParams.toString();
  };

  const handleCallback = async params => {
    try {
      setState({ ...state, loading: true });
      await apiWalmartCallback(params);
      history.push("/user/walmart-integration");
    } catch (e) {
      setState({
        ...state,
        loading: false,
        error: e.message ? e.message : e
      });
    }
  };

  const copyErrorMessage = () => {
    if (errorElm.current) {
      navigator.clipboard.writeText(errorElm.current.innerText);
      enqueueSnackbar("Copied to clipboard", {
        variant: "success",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        autoHideDuration: 1400
      });
    }
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const type = params.get("type");
    const sellerId = params.get("sellerId");
    const state = params.get("state");
    let marketplace = "";
    if (state) {
      const [_, m] = state.split("-");
      marketplace = m;
    }
    handleCallback({ code, type, sellerId, marketplace });
  }, []);

  return (
    <Flex
      justify="center"
      style={{
        paddingTop: "5%"
      }}
    >
      {state.error ? (
        <Flex vertical justify="center" align="center">
          <Text type="danger" style={{ fontSize: 18 }}>
            {state.error}
          </Text>
          <Link href="/user/walmart-integration">Go back</Link>
        </Flex>
      ) : null}
      {state.loading ? <Spin>Please wait...</Spin> : null}
    </Flex>
  );
};

export default connectAutoDispatch(
  state => ({ userInfo: state.userState.userInfo }),
  {}
)(WalmartCallback);
